@charset "UTF-8";

/* src/app/components/v2-open-binders/v2-open-binders.component.scss */
:host {
  display: contents;
}
body.v2-open-binders-open {
  overflow: hidden;
}
.v2-open-binders {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: 50% 50%;
  animation: v2-open-binders-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  background: var(--exme-overlay-atmosphere-background);
}
.v2-open-binders.v2-open-binders--closing {
  pointer-events: none;
  animation: v2-open-binders-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-open-binders-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-open-binders-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-open-binders {
    animation: none;
  }
  .v2-open-binders.v2-open-binders--closing {
    animation: none;
    opacity: 0;
  }
}
.v2-open-binders .v2-rpc-floating-close {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
body.dark .v2-open-binders .v2-rpc-floating-close {
  background: rgba(22, 28, 36, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-open-binders .v2-rpc-title-pill {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(13, 18, 24, 0.07);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
body.dark .v2-open-binders .v2-rpc-title-pill {
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
}
.v2-open-binders .manage-wrapper.v2-req-phys-wrap.v2-open-binders-empty-rpc .v2-rpc-item {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.07) !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
body.dark .v2-open-binders .manage-wrapper.v2-req-phys-wrap.v2-open-binders-empty-rpc .v2-rpc-item {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);
}
.manage-header-wrapper {
  flex-shrink: 0;
  padding: 0.5rem 0.5rem 0 0.5rem;
  position: sticky;
  top: 0;
  z-index: 20;
  background: var(--ion-color-background);
}
.manage-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  gap: 0.5rem;
  background: var(--ion-color-primary-medium);
  border-radius: 25px;
  transform: translateY(-100%) scale(0);
  transition: transform 0.6s ease;
}
.manage-header.opened.loaded {
  transform: translateY(0) scale(1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.manage-header-center {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}
.manage-header-title {
  margin: 0;
  width: 100%;
  text-align: center;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--ion-color-primary);
  line-height: 1.2;
}
.v2-open-binders-progress {
  width: 100%;
  max-width: 200px;
  height: 4px;
  border-radius: 4px;
}
.manage-header-spacer {
  width: 44px;
  flex-shrink: 0;
}
.manage-content {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: var(--ion-color-background);
  transition: background 0.3s ease;
}
.v2-open-binders-scroll {
  -webkit-overflow-scrolling: touch;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
.manage-wrapper {
  padding: clamp(1rem, 4vw, 1.4rem) clamp(1rem, 4vw, 1.25rem);
  padding-bottom: calc(3rem + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 520px;
  margin-inline: auto;
  width: 100%;
}
.manage-wrapper > * {
  opacity: 0;
  transform: scale(0.9) translateY(-40px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.manage-wrapper.opened.loaded > * {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.manage-wrapper.opened.loaded > *:nth-child(1) {
  transition-delay: 0.35s;
}
.manage-wrapper.opened.loaded > *:nth-child(2) {
  transition-delay: 0.5s;
}
.manage-wrapper.opened.loaded > *:nth-child(3) {
  transition-delay: 0.65s;
}
.manage-wrapper.opened.loaded > *:nth-child(4) {
  transition-delay: 0.8s;
}
.manage-wrapper.opened.loaded > *:nth-child(5) {
  transition-delay: 0.95s;
}
.manage-wrapper.opened.loaded > *:nth-child(6) {
  transition-delay: 1.1s;
}
.manage-wrapper.opened.loaded > *:nth-child(7) {
  transition-delay: 1.25s;
}
.manage-wrapper.opened.loaded > *:nth-child(8) {
  transition-delay: 1.4s;
}
.manage-wrapper.opened.loaded > *:nth-child(9) {
  transition-delay: 1.55s;
}
.manage-wrapper.opened.loaded > *:nth-child(10) {
  transition-delay: 1.7s;
}
.manage-wrapper.opened.loaded > *:nth-child(11) {
  transition-delay: 1.85s;
}
.manage-wrapper.opened.loaded > *:nth-child(12) {
  transition-delay: 2s;
}
.manage-wrapper.opened.loaded > *:nth-child(13) {
  transition-delay: 2.15s;
}
.manage-wrapper.opened.loaded > *:nth-child(14) {
  transition-delay: 2.3s;
}
.manage-wrapper.opened.loaded > *:nth-child(15) {
  transition-delay: 2.45s;
}
.manage-wrapper.opened.loaded > *:nth-child(16) {
  transition-delay: 2.6s;
}
@media (prefers-reduced-motion: reduce) {
  .manage-wrapper > * {
    opacity: 1;
    transform: none;
    transition: opacity 0.2s ease;
  }
  .manage-wrapper.opened.loaded > * {
    transition-delay: 0s !important;
  }
  .manage-wrapper.opened.loaded .v2-ob-count-column > app-btn {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
.v2-ob-panel {
  background: var(--ion-color-primary-low);
  border-radius: 18px;
  padding: clamp(1rem, 4vw, 1.35rem);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}
.v2-ob-panel--top {
  padding: clamp(1rem, 3vw, 1.25rem);
}
.v2-ob-panel--top + * {
  margin-top: -0.35rem;
}
.v2-ob-top-section {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: clamp(0.5rem, 2.5vw, 1.2rem);
  min-width: 0;
}
.v2-ob-collection-image {
  flex: 0 0 auto;
  width: 140px;
  height: 140px;
}
@media (max-width: 420px) {
  .v2-ob-collection-image {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 380px) {
  .v2-ob-collection-image {
    width: 100px;
    height: 100px;
  }
}
.v2-ob-image-frame {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: var(--ion-color-primary-low);
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.v2-ob-image-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-step-100, #f0f0f0) 0%,
      var(--ion-color-step-150, #e8e8e8) 100%);
  border: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.v2-ob-stats-side {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  gap: 0.45rem;
}
.v2-ob-metric {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.35rem;
  align-self: flex-start;
  max-width: 100%;
  min-width: 0;
  padding: 0.4rem 0.55rem;
  border-radius: 999px;
  background: var(--ion-color-primary-medium);
  border: 1px solid var(--ion-color-step-100, rgba(0, 0, 0, 0.06));
  width: 100%;
}
.v2-ob-metric-label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 400px) {
  .v2-ob-metric-label {
    font-size: 0.72rem;
  }
  .v2-ob-metric {
    gap: 0.5rem;
    padding: 0.45rem 0.75rem;
  }
}
.v2-ob-metric-value {
  flex-shrink: 0;
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1;
  color: var(--ion-color-primary);
  font-variant-numeric: tabular-nums;
}
@media (min-width: 400px) {
  .v2-ob-metric-value {
    font-size: 1.2rem;
  }
}
.v2-ob-metric--zero .v2-ob-metric-value {
  color: var(--ion-color-text);
}
.v2-ob-collection-title {
  margin: 0 0 0.15rem;
  font-size: clamp(0.95rem, 3.5vw, 1.1rem);
  font-weight: 700;
  line-height: 1.25;
  color: var(--ion-color-text);
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-align: center;
}
.v2-ob-meta {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--ion-color-text);
  max-width: 100%;
}
.v2-ob-body {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--ion-color-text);
  max-width: 36rem;
  margin-inline: auto;
}
.v2-ob-copy-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.v2-ob-section-label {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  max-width: 36rem;
  margin-inline: auto;
}
.v2-ob-count-column {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
}
@keyframes v2-ob-option-in {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.v2-ob-count-column > app-btn {
  display: block;
  opacity: 0;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn {
  animation: v2-ob-option-in 0.5s ease forwards;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(1) {
  animation-delay: 0.35s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(2) {
  animation-delay: 0.5s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(3) {
  animation-delay: 0.65s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(4) {
  animation-delay: 0.8s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(5) {
  animation-delay: 0.95s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(6) {
  animation-delay: 1.1s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(7) {
  animation-delay: 1.25s;
}
.manage-wrapper.opened.loaded .v2-ob-count-column > app-btn:nth-child(8) {
  animation-delay: 1.4s;
}
.v2-ob-helper {
  margin: 0.35rem 0 0;
  padding: 0 0.25rem;
  text-align: center;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--ion-color-text);
  max-width: 22rem;
  margin-inline: auto;
}
.v2-ob-count-column .btn-wrapper {
  width: 100%;
}
.v2-ob-count-column .btn-wrapper .btn {
  min-height: 48px;
  padding: 0.72rem 0.85rem;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.2;
  border-radius: 14px;
  text-align: center;
}
.v2-ob-secondary-actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ion-color-step-100, rgba(0, 0, 0, 0.08));
}
.v2-open-binders-rpc-progress {
  position: fixed;
  top: 3.35rem;
  left: 50%;
  transform: translateX(-50%);
  width: min(220px, 70vw);
  z-index: 62;
  pointer-events: none;
}
.v2-open-binders-rpc-progress ion-progress-bar {
  height: 3px;
  border-radius: 999px;
  overflow: hidden;
}
.v2-ob-empty-rpc-icon {
  display: flex;
  justify-content: center;
  padding: 0.15rem 0 0.35rem;
}
.v2-ob-empty-rpc-icon__frame {
  width: 112px;
  height: 112px;
  flex-shrink: 0;
  border-radius: 16px;
  overflow: hidden;
}
.v2-req-phys-wrap .v2-rpc-item .v2-open-binders-empty-rpc__secondary {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}
.v2-ob-eyebrow {
  margin: 0 0 0.15rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ion-color-text);
  line-height: 1.3;
}
.v2-ob-empty {
  text-align: center;
  padding: 0.35rem 0.5rem 0.15rem;
}
.v2-ob-empty-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--ion-color-text);
}
.v2-ob-empty-hint {
  margin: 0.5rem 0 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--ion-color-text);
}
ion-img.v2-ob-hero-img {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.35s ease-in-out;
}
ion-img.v2-ob-hero-img.fade {
  opacity: 1;
}
ion-img.v2-ob-hero-img::part(image) {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.v2-open-binders {
  --v2-ob-shimmer-base-rgb: var(--ion-background-color-rgb, 235, 235, 235);
  --v2-ob-shimmer-highlight-rgb: var(--ion-color-step-100, 250, 250, 250);
}
body.dark .v2-open-binders {
  --v2-ob-shimmer-base-rgb:
    40,
    40,
    40;
  --v2-ob-shimmer-highlight-rgb:
    70,
    70,
    70;
}
.v2-ob-img-shimmer {
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
  background-image:
    linear-gradient(
      90deg,
      rgba(var(--v2-ob-shimmer-base-rgb), 0.35) 0%,
      rgba(var(--v2-ob-shimmer-highlight-rgb), 0.55) 45%,
      rgba(var(--v2-ob-shimmer-highlight-rgb), 0.75) 50%,
      rgba(var(--v2-ob-shimmer-highlight-rgb), 0.55) 55%,
      rgba(var(--v2-ob-shimmer-base-rgb), 0.35) 100%);
  background-size: 220% 100%;
  animation: v2-ob-img-shimmer 1.7s infinite cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes v2-ob-img-shimmer {
  0% {
    background-position: 180% 0;
  }
  100% {
    background-position: -180% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-ob-img-shimmer {
    animation: none;
    opacity: 0.85;
  }
}
.v2-ob-skeleton-panel {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  padding: 0.5rem 0 1.5rem;
  min-height: 220px;
}
.v2-ob-skeleton-top-row {
  display: flex;
  gap: 1.2rem;
  align-items: stretch;
}
.v2-ob-skeleton-stats {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  justify-content: center;
  min-width: 0;
}
.v2-ob-skeleton-hero {
  flex-shrink: 0;
  width: 140px;
  height: 140px;
  border-radius: 16px;
  background:
    linear-gradient(
      90deg,
      var(--ion-color-step-150, #e8e8e8) 0%,
      var(--ion-color-step-100, #f0f0f0) 50%,
      var(--ion-color-step-150, #e8e8e8) 100%);
  background-size: 200% 100%;
  animation: v2-ob-shimmer 1.2s ease-in-out infinite;
}
@media (max-width: 420px) {
  .v2-ob-skeleton-hero {
    width: 120px;
    height: 120px;
  }
}
.v2-ob-skeleton-line {
  height: 14px;
  border-radius: 8px;
  max-width: 100%;
  background: var(--ion-color-step-150, #e8e8e8);
  animation: v2-ob-shimmer 1.2s ease-in-out infinite;
}
.v2-ob-skeleton-line--short {
  max-width: 65%;
}
.v2-ob-skeleton-line--medium {
  max-width: 85%;
}
.v2-ob-skeleton-actions {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
}
.v2-ob-skeleton-btn-bar {
  width: 100%;
  height: 48px;
  border-radius: 14px;
  background: var(--ion-color-step-150, #e8e8e8);
  animation: v2-ob-shimmer 1.2s ease-in-out infinite;
}
.v2-ob-skeleton-btn-bar--short {
  width: 72%;
  max-width: 280px;
}
.v2-ob-loading-caption {
  margin: 0.5rem 0 0;
  text-align: center;
  font-size: 0.9rem;
  color: var(--ion-color-text);
}
@keyframes v2-ob-shimmer {
  0% {
    opacity: 0.65;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.65;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-ob-skeleton-hero,
  .v2-ob-skeleton-line,
  .v2-ob-skeleton-btn-bar {
    animation: none;
    opacity: 0.85;
  }
}
.v2-open-binders .btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 3px;
}
.sc-ion-label-md-s > p {
  color: var(--ion-color-text-87);
}
.v2-rpc-submit-wrap {
  max-width: min(32rem, 100%);
  margin: 1.25rem auto 0;
  padding: 0 0.85rem calc(1rem + env(safe-area-inset-bottom));
}
/*# sourceMappingURL=v2-open-binders.component.css.map */
